<template>
  <div class="radom-person">
    <img v-if="persons.length === 0" class="empt_person" src="@/assets/image/icon_empt.png" alt="" />
    <div class="person-list">
      <div v-for="(person, index) in persons" :key="index" class="item">
        <img src="@/assets/image/user.png" alt="" />
        <span>{{ person.n }}</span>
      </div>
    </div>
    <div class="bottom-btn">
      <span @click="onClear" class="clear">清空</span>
      <van-button @click="onSelect" style="flex:1" round type="info">选人</van-button>
    </div>

    <van-action-sheet v-model="show" title="请确定要选取的人数">
      <div class="content">
        <div class="content-item" v-for="i in 10" :key="i">
          <span @click="handle2ChoosePerson(i)" :class="{active: value == i}">{{ i }}</span>
        </div>
      </div>
    </van-action-sheet>

    <!-- <Back /> -->
  </div>
</template>

<script>
// import back from '../../../components/back.vue'
// eslint-disable-next-line no-unused-vars
import {wsMixin} from '@/views/activePlay/wsMixin.js'
export default {
  mixins: [wsMixin],
  // components: {back},
  data() {
    return {
      id: this.$route.params.id,
      value: 0,
      show: true,
      persons: []
    }
  },
  methods: {
    receiveMsg({data}) {
      const msg = JSON.parse(data)
      if (msg.c === 40001) {
        this.persons = [...this.persons, ...msg.u]
      }
    },
    onClear() {
      if (!this.persons.length) {
        return this.$Toast.fail('当前数据为空')
      }
      this.$dialog
        .confirm({
          message: '确定清空所有选人结果?',
          confirmButtonColor: 'rgba(68,101,243,1)'
        })
        .then(() => {
          this.persons = []
        })
    },
    onSelect() {
      this.value = 0
      this.show = true
    },
    handle2ChoosePerson(i) {
      this.value = i
      this.show = false
      if (this.wsOpen) {
        const obj = {
          c: 40001,
          e: this.id,
          g: i,
          d: {
            r: this.id
          }
        }
        this.ws.send(JSON.stringify(obj))
      } else {
        return this.$Toast.success('选取失败，请重试')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.radom-person {
  min-height: 100vh;
  padding-bottom: 60px;
  position: relative;
}

.person-list {
  .item {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    span {
      flex: 1;
    }
    img {
      width: 48px;
      height: 48px;
      margin-right: 10px;
    }
  }
}

.bottom-btn {
  background: #fff;
  box-shadow: 0px -3px 8px 0px rgba(0, 0, 0, 0.04);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  padding: 8px;
  display: flex;
  align-items: center;
  .clear {
    width: 80px;
    text-align: center;
  }
}
.content {
  padding: 10px 40px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.content-item {
  width: 20%;
  margin-bottom: 20px;
  span {
    display: inline-block;
    width: 48px;
    height: 48px;
    border: 1px solid #dcdfe6;
    border-radius: 50%;
    text-align: center;
    line-height: 48px;
  }
  span.active {
    background: #4465f3;
    border-color: #4465f3;
    color: #fff;
  }
}
.empt_person {
  width: 240px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
